import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import 'aos/dist/aos.css';
import AOS from 'aos';
import whobanner from "../img/cyber.png";
import { FaMobileAlt, FaDesktop, FaDraftingCompass, FaProjectDiagram, FaPencilRuler, FaSyncAlt, FaUsers, FaLightbulb, FaHeadset, FaClock } from 'react-icons/fa';

/**
 * UIUXDesignServices.responsive.jsx
 *
 * Matches the same UI structure, accessibility and responsive behavior used across
 * your other service pages (hero, intro, services, process, tech, why-choose,
 * FAQs and quote form).
 */

const UIUXDesignServices = ({ name }) => {
  const videoRef = useRef(null);
  const [openFAQ, setOpenFAQ] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneno: '',
    country_code: '',
    location: '',
    industry_type: '',
    availability: '',
    type_of_service: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formMessage, setFormMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({ title: '', message: '', status: 'info' });
  const navigate = useNavigate();

  // Small helper so onClick analytics/click-tracking calls don't trigger lint errors
  const handleLinkClick = (path, pageName) => {
    // keep this simple — replace with analytics/event tracking if needed
    // console.log(`Navigated to ${pageName} at ${path}`);
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const nameRegex = /^[A-Za-z\s]+$/;
const phoneDigitsRegex = /^[0-9]{10}$/;


  const countryCodes = [
    { code: '+91', flag: '🇮🇳', label: 'India' },
    { code: '+1', flag: '🇺🇸', label: 'United States' },
    { code: '+44', flag: '🇬🇧', label: 'United Kingdom' },
    { code: '+61', flag: '🇦🇺', label: 'Australia' },
    { code: '+971', flag: '🇦🇪', label: 'UAE' },
  ];

  const API_BASE = process.env.REACT_APP_API_URL || 'https://api.securxperts.com:8000';

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 900, once: true, easing: 'ease-in-out' });

    const handleScroll = () => {
      if (videoRef.current) {
        const translateY = window.scrollY * 0.25;
        videoRef.current.style.transform = `translateY(${translateY}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [name]);

  const toggleFAQ = (index) => setOpenFAQ(openFAQ === index ? null : index);

const handleInputChange = (e) => {
  const { id, value } = e.target;

  // Name: allow only alphabets & spaces
  if (id === "name") {
    if (!/^[A-Za-z\s]*$/.test(value)) return;
  }

  // Phone: allow only numbers & max 10 digits
  if (id === "phoneno") {
    if (!/^[0-9]*$/.test(value)) return;
    if (value.length > 10) return;
  }

  setFormData(prev => ({ ...prev, [id]: value }));
};

  const handleCountryCodeChange = (e) => setFormData(prev => ({ ...prev, country_code: e.target.value }));

const validateForm = () => {
  const { name, email, phoneno, country_code, location, industry_type, availability, type_of_service } = formData;

  if (!name || !email || !phoneno || !country_code || !location || !industry_type || !availability || !type_of_service) {
    return 'Please fill out all fields.';
  }

  if (!nameRegex.test(name)) {
    return 'Name should contain only alphabets.';
  }

  if (!emailRegex.test(email)) {
    return 'Please enter a valid email address.';
  }

  if (!phoneDigitsRegex.test(phoneno)) {
    return 'Phone number must be exactly 10 digits.';
  }

  return null;
};


  const openModal = (title, message, status = 'info') => {
    setModalContent({ title, message, status });
    setShowModal(true);
  };
  const closeModal = () => setShowModal(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormMessage('');
    const error = validateForm();
    if (error) {
      setFormMessage(error);
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = { ...formData };
      const response = await fetch(`${API_BASE}/forms/services`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const text = await response.text().catch(() => '');
        throw new Error(`HTTP ${response.status} ${text || ''}`.trim());
      }

      const result = await response.json().catch(() => ({}));
      const success = result && (result.success === true || (result.message && /success/i.test(result.message)));

if (success) {

  openModal(
    'Success',
    'Your form has been submitted successfully.',
    'Success'
  );

  setFormData({
    name: '',
    email: '',
    phoneno: '',
    country_code: '+91',
    location: '',
    industry_type: '',
    availability: '',
    type_of_service: '',
  });

  // Keep popup open for 5 seconds
  setTimeout(() => {
    closeModal();
  }, 5000);

} else {
  const msg = result?.message || 'Failed to send request. Please try again later.';
  setFormMessage(msg);
}

    } catch (err) {
      setFormMessage(err?.message || 'Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  // Scroll-to-top state
  const [showScroll, setShowScroll] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  useEffect(() => {
    let ticking = false;
    const circumference = 307.919;

    const updateProgress = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      const progress = (scrollTop / docHeight) * circumference;
      setScrollProgress(progress);
      setShowScroll(scrollTop > 120);
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateProgress);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    updateProgress();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // const handleLinkClick = (path, pageName) => console.log(`Navigated to ${pageName} at ${path}`);

  const cardStyle = { background: '#ECF0FE', color: '#210A4A' };
  const iconContainerStyle = { background: 'white' };

  return (
    <div className="min-h-screen bg-white font-sans text-base leading-relaxed">
      <Helmet>
        <title>UI/UX Design Services | SecurXpert — User-Centered Digital Design</title>
        <meta name="description" content="SecurXpert offers UI/UX design services for web and mobile apps, creating intuitive, visually appealing interfaces to boost usability, engagement and conversions." />
      </Helmet>

      <Navbar />

      {/* HERO */}
      <header className="relative w-full">
  <div
    className="relative w-full h-[317px] bg-center bg-cover bg-no-repeat"
    style={{ backgroundImage: `url(${whobanner})` }}
  >
    {/* Dark overlay */}
    <div className="absolute inset-0 bg-black/55 lg:bg-black/60" />

    {/* Centered text content */}
    <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 drop-shadow-md">
        UI/UX Design Services
      </h1>

      <div className="flex items-center gap-2 text-sm sm:text-base">
        <Link to="/" className="hover:underline">Home</Link>
        <svg
          width="7"
          height="10"
          viewBox="0 0 7 10"
          fill="none"
          className="mt-[2px]"
        >
          <path
            d="M0.297 0.262C0.105 0.426 -0.002 0.648 0 0.878C0.002 1.109 0.113 1.329 0.308 1.492L4.02 4.604L0.366 7.711C0.173 7.875 0.067 8.097 0.069 8.328C0.071 8.558 0.182 8.778 0.377 8.941C0.474 9.022 0.59 9.086 0.717 9.13C0.844 9.174 0.981 9.196 1.118 9.195C1.255 9.194 1.391 9.171 1.518 9.126C1.644 9.081 1.758 9.016 1.854 8.933L6.232 5.212C6.329 5.131 6.405 5.034 6.457 4.927C6.509 4.821 6.535 4.706 6.534 4.591C6.533 4.476 6.505 4.362 6.451 4.256C6.397 4.15 6.319 4.054 6.221 3.974L1.774 0.254C1.677 0.173 1.561 0.109 1.434 0.065C1.307 0.021 1.171 -0.001 1.033 0C0.896 0.001 0.76 0.024 0.634 0.069C0.507 0.114 0.393 0.18 0.297 0.262Z"
            fill="white"
          />
        </svg>
        <span>UI/UX Design Services</span>
      </div>
    </div>
  </div>
</header>

      {/* SERVICES */}
      <section className="py-10 sm:py-14 md:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div className="relative w-full">
              <img src="img/ui.jpg" alt="UI UX design mockup showing web and mobile interface designs" className="w-full h-56 sm:h-64 md:h-80 lg:h-96 object-cover rounded-xl shadow-xl" loading="lazy" />
            </div>
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-4 text-[#210A4A]">Smart User Experience Design</h2>
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-6">Our UI/UX design approach focuses on user behavior, usability, accessibility, and aesthetics to create intuitive digital experiences that drive engagement and conversions.</p>
              <Link to="/contact-us" onClick={() => handleLinkClick('/get-quoted', 'Get Started Today')} className="inline-block px-6 py-3 rounded-full font-semibold text-white bg-[#3E66F3] hover:bg-[#355fd3] transition">Get Started Today</Link>
            </div>
          </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
  {[
    { 
      title: 'UI Design', 
      icon: <FaPencilRuler className="text-3xl" />, 
      description: 'Striking, brand-first UI that balances aesthetics with usability.',
      aria: ' User interface design mockup with branding colors'
    },
    { 
      title: 'UX Design', 
      icon: <FaProjectDiagram className="text-3xl" />, 
      description: 'User flows and interaction design that reduce friction and improve outcomes.',
      aria: 'User experience flowchart showing optimized navigation'
    },
    { 
      title: 'Mobile App UX & UI', 
      icon: <FaMobileAlt className="text-3xl" />, 
      description: 'Optimised interfaces for iOS and Android with clear, efficient navigation.',
      aria: 'Mobile app UI UX design for iOS and Android devices'
    },
    { 
      title: 'Wireframing & Prototyping', 
      icon: <FaDraftingCompass className="text-3xl" />, 
      description: 'Clickable prototypes to test ideas early and reduce rework.',
      aria: 'Wireframe and interactive prototype of a mobile app'
    },
    { 
      title: 'Responsive Web Design', 
      icon: <FaDesktop className="text-3xl" />, 
      description: 'Designs that adapt seamlessly to desktop, tablet and mobile.',
      aria: 'Responsive web design layout on multiple devices'
    },
    { 
      title: 'Redesign Services', 
      icon: <FaSyncAlt className="text-3xl" />, 
      description: 'Modernise legacy interfaces to improve engagement and conversions.',
      aria: 'Before and after UI redesign comparison'
    },
  ].map((item, i) => (
    <article
      key={i}
      className="rounded-xl shadow-lg p-6 flex flex-col items-center text-center hover:shadow-2xl transform transition hover:scale-[1.02]"
      style={cardStyle}
      aria-label={item.aria}
      title={item.title}
    >
      <div 
        className="bg-white rounded-full p-3 w-16 h-16 flex items-center justify-center mb-4" 
        style={iconContainerStyle}
        aria-hidden="true"
      >
        {item.icon}
      </div>
      <h3 className="text-lg font-bold mb-2" style={{ color: cardStyle.color }}>{item.title}</h3>
      <p className="text-sm leading-relaxed text-gray-700">{item.description}</p>
    </article>
  ))}
</div>

        </div>
      </section>

      {/* PROCESS */}
      <section className="py-10 md:py-14 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-center mb-8 text-[#210A4A]">Our UI/UX Design Process</h2>
          <p className='text-center'>Our design process includes research, wireframing, prototyping, visual design and usability testing to deliver seamless user experiences.</p>
          <div className="space-y-8">
            {[
              { number: '1', title: 'Research & Analysis', desc: 'We study your business, competitors and users to understand needs and pain points.' },
              { number: '2', title: 'Wireframing & Planning', desc: 'Structured layouts and flows that map the user journey.' },
              { number: '3', title: 'Prototyping', desc: 'Interactive prototypes to validate ideas before development.' },
              { number: '4', title: 'UI Design', desc: 'Visual design focusing on branding, colour and typography.' },
              { number: '5', title: 'UX Design & Testing', desc: 'Usability testing and iteration to refine navigation and interactions.' },
              { number: '6', title: 'Final Implementation & Delivery', desc: 'Handoff-ready assets and responsive design delivery.' },
              { number: '7', title: 'Continuous Feedback & Improvement', desc: 'Collect feedback and optimize the design post-launch.' },
            ].map((step, i) => (
              <div key={i} className="flex flex-col lg:flex-row items-center gap-6 lg:gap-8" data-aos={i % 2 === 0 ? 'fade-right' : 'fade-left'}>
                <div className="w-full lg:w-56 h-28 rounded-3xl flex items-center justify-center text-white shadow-xl mb-4 lg:mb-0" style={{ background: i % 2 === 0 ? 'linear-gradient(180deg, #421492 0%, #14062C 100%)' : 'linear-gradient(180deg, #4E18B0 0%, #210A4A 100%)' }}>
                  <div className="text-4xl font-bold opacity-60">{step.number}</div>
                </div>
                <div className="w-full bg-white rounded-2xl shadow-lg p-6 sm:p-8">
                  <h3 className="text-xl font-bold text-[#210A4A] mb-2">{step.title}</h3>
                  <p className="text-gray-700">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHY CHOOSE */}
      <section className="py-10 bg-[#DBE3FF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center mb-6 text-[#210A4A]">Why Choose Our UI/UX Design Services</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {[
              { title: 'Modern UI/UX Design Services', text: 'Visually appealing interfaces that keep users engaged and boost growth.' },
              { title: 'Data-Driven UI/UX Strategy', text: 'Research and analytics at the core to improve usability and conversions.' },
              { title: 'AI-Powered UI/UX Solutions', text: 'AI-driven insights to personalise and optimise user experiences.' },
              { title: 'Designs Built for Business Growth', text: 'Scalable systems that evolve with your brand.' },
            ].map((item, i) => (
              <div key={i} className="bg-white rounded-xl p-4 flex items-start gap-4 shadow-md">
                <div className="text-[#210A4A]"><FaLightbulb className="text-3xl" /></div>
                <div>
                  <h3 className="text-lg font-bold text-[#210A4A]">{item.title}</h3>
                  <p className="text-gray-700 text-sm">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TECHNOLOGIES */}
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center mb-6 text-[#210A4A]">Technologies We Use</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { title: 'Design Tools', items: 'Figma, Adobe XD, Sketch' },
              { title: 'Prototyping', items: 'InVision, Marvel' },
              { title: 'Front-End', items: 'HTML5, CSS3, ReactJS' },
              { title: 'Mobile', items: 'Flutter, React Native' },
            ].map((item, i) => (
              <div key={i} className="bg-white rounded-xl shadow-lg p-6 text-center">
                <h4 className="text-lg font-bold mb-2 text-[#210A4A]">{item.title}</h4>
                <p className="text-gray-700 text-sm">{item.items}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-10 text-center bg-[#DBE3FF]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-4 text-[#210A4A]">Ready to Enhance Your Digital Experience?</h2>
          <p className="text-gray-700 mb-6">Designing apps and websites doesn't have to be hard. SecurXpert crafts visually appealing interfaces and ensures smooth, intuitive interactions.</p>
          <Link to="/contact-us" onClick={() => handleLinkClick('/contact-us', 'Book a Free Consultation')} className="inline-block px-8 py-3 rounded-full font-semibold text-white bg-[#210A4A] hover:bg-indigo-900">Book a Free Consultation</Link>
        </div>
      </section>

      {/* FAQs */}
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center mb-8 text-[#210A4A]">FAQs</h2>
                    <p className='text-center'>If your question isn’t listed, please contact our team with details about your request so we can assist you more efficiently.</p>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="space-y-4">
              {[
                { q: 'How does UI/UX design benefit a business?', a: 'It improves user satisfaction, boosts engagement, and increases conversions.' },
                { q: 'What is UX design?', a: 'UX design ensures smooth, easy, and enjoyable user experiences.' },
                { q: 'Why is UI/UX important for business growth?', a: 'Good UI/UX reduces bounce rates and builds brand loyalty.' },
                { q: 'How can I start with UI/UX design services?', a: 'Reach out via phone, email or website for a custom design plan.' },
              ].map((faq, i) => (
                <div key={i} className="border rounded-lg shadow-sm overflow-hidden">
                  <button id={`faq-btn-${i}`} type="button" onClick={() => toggleFAQ(i)} aria-expanded={openFAQ === i} aria-controls={`faq-panel-${i}`} className="w-full flex items-center justify-between px-4 sm:px-6 py-3 bg-white text-left focus:outline-none focus:ring-2 focus:ring-[#210A4A]">
                    <span className="font-semibold">{faq.q}</span>
                    <svg className={`w-5 h-5 transform transition-transform ${openFAQ === i ? 'rotate-180' : 'rotate-0'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7"/></svg>
                  </button>
                  <div id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-btn-${i}`} className={`px-4 sm:px-6 overflow-hidden transition-[max-height,opacity] duration-300 ${openFAQ === i ? 'py-4 opacity-100' : 'py-0 opacity-0'}`} style={{ maxHeight: openFAQ === i ? '400px' : '0' }}>
                    <p className="text-gray-700">{faq.a}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg flex flex-col items-center">
              <img src="/img/needmorehelp.png" alt="Frequently asked questions about AI chatbot development" className="w-full sm:w-3/4 h-48 object-cover rounded-lg mb-4" />
              <h3 className="text-xl font-bold text-[#210A4A]">Need more help?</h3>
              <p className="text-gray-600 text-center mt-2">If your question isn’t listed, please contact our team with details about your request so we can assist you more efficiently.</p>
              <Link to="/contact-us" onClick={() => handleLinkClick('/contact-us', 'Contact Support')} className="mt-4 inline-block px-6 py-3 rounded-full bg-[#3E66F3] text-white font-semibold hover:bg-indigo-700">Contact Support</Link>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT / QUOTE FORM */}
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div className="space-y-6">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-[#210A4A]">Request a <span className="text-[#3E66F3]">Call Back</span></h2>
              <p className="text-gray-700">Get a tailored UI/UX plan — wireframes, prototypes, and design systems that increase conversions.</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-center gap-4 bg-white p-4 rounded-lg shadow-md">
                  <div className="p-3 rounded-full bg-[#ECF0FE] text-[#3E66F3]"><FaHeadset className="text-2xl" /></div>
                  <span className="text-gray-700 font-medium">Reply within 24 hours</span>
                </div>
                <div className="flex items-center gap-4 bg-white p-4 rounded-lg shadow-md">
                  <div className="p-3 rounded-full bg-[#ECF0FE] text-[#3E66F3]"><FaClock className="text-2xl" /></div>
                  <span className="text-gray-700 font-medium">24/7 Support</span>
                </div>
              </div>
              <div className="mt-6 text-center lg:text-left">
                <div className="inline-flex items-center justify-center text-white p-6 rounded-full w-28 h-28 shadow-lg bg-[#3E66F3]">
                  <FaHeadset className="text-3xl" />
                </div>
                <h5 className="text-gray-700 mt-4">Call us anytime</h5>
                <h3 className="text-gray-800 font-bold">+91 79932 56679</h3>
              </div>
            </div>

            <div className="bg-white border border-gray-100 rounded-xl shadow-xl p-6 sm:p-8">
              <form onSubmit={handleSubmit} noValidate className="space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="sm:col-span-2">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Full name</label>
                    <input id="name" type="text" placeholder="e.g., John Doe" value={formData.name} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]" required />
                  </div>

                  <div className="sm:col-span-2">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email address</label>
                    <input id="email" type="email" placeholder="you@example.com" value={formData.email} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]" inputMode="email" required />
                  </div>

                  <div className="sm:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Phone number</label>
                    <div className="flex gap-3 flex-col sm:flex-row">
                      <select
  id="country_code"
  value={formData.country_code}
  onChange={handleCountryCodeChange}
  className="border border-gray-300 rounded-lg px-3 py-3 bg-white w-full sm:w-44"
  aria-label="Country code"
  required
>
  <option value="" disabled>
    Select country code
  </option>

  {countryCodes.map((c, idx) => (
    <option key={idx} value={c.code}>
      {`${c.flag} ${c.code} (${c.label})`}
    </option>
  ))}
</select>


                      <input id="phoneno" type="tel" placeholder="1234567890" value={formData.phoneno} onChange={handleInputChange} className="flex-1 border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3] w-full" inputMode="numeric" pattern="[0-9]*" aria-describedby="phone-help" required />
                    </div>
                    {/* <p id="phone-help" className="text-xs text-gray-500 mt-2">Digits only (7–15). Country code selected separately.</p> */}
                  </div>

                  <div>
                    <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-1">Location</label>
                    <input id="location" type="text" placeholder="City, State or Country" value={formData.location} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]" required />
                  </div>

                  <div>
                    <label htmlFor="industry_type" className="block text-sm font-medium text-gray-700 mb-1">Industry type</label>
                    <select id="industry_type" value={formData.industry_type} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]" required>
                      <option value="" disabled>Select Industry Type</option>
                      <option>Finance</option>
                      <option>Healthcare</option>
                      <option>Retail</option>
                      <option>Education</option>
                      <option>Manufacturing</option>
                      <option>Other</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="availability" className="block text-sm font-medium text-gray-700 mb-1">Availability</label>
                    <select id="availability" value={formData.availability} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]" required>
                      <option value="" disabled>Availability</option>
                      <option>Immediate</option>
                      <option>1-2 weeks</option>
                      <option>1 month+</option>
                    </select>
                  </div>

                  <div className="sm:col-span-2">
                    <label htmlFor="type_of_service" className="block text-sm font-medium text-gray-700 mb-1">Type of service</label>
                    <select id="type_of_service" value={formData.type_of_service} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]" required>
                      <option value="" disabled>Select Type of Service</option>
                      <option>UI Design</option>
                      <option>UX Design</option>
                      <option>Mobile App UX/UI</option>
                      <option>Wireframing & Prototyping</option>
                      <option>Redesign Services</option>
                    </select>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <button type="submit" disabled={isSubmitting} className="w-full text-white font-semibold py-3 rounded-lg text-lg bg-[#210A4A] disabled:opacity-60 hover:bg-indigo-900">{isSubmitting ? 'Sending...' : 'Send Message'}</button>
                </div>

                {formMessage && <div className={`text-center font-medium ${formMessage.toLowerCase().includes('success') ? 'text-green-600' : 'text-red-600'}`}>{formMessage}</div>}
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
{/* Back to Top */}
      {showScroll && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full shadow-lg bg-gradient-to-r from-blue-500 to-blue-700"
          aria-label="Scroll to top"
        >
          <svg
            className="progress-circle -rotate-90 w-12 h-12 absolute"
            viewBox="-1 -1 102 102"
            aria-hidden
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              fill="none"
              stroke="white"
              strokeWidth="4"
              strokeDasharray="307.919"
              strokeDashoffset={307.919 - scrollProgress}
              style={{ transition: 'stroke-dashoffset 0.15s linear' }}
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 text-white relative z-10"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            aria-hidden
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
          </svg>
        </button>
      )}

      {/* SUCCESS POPUP (PRODUCT PAGE STYLE) */}
      {showModal && (modalContent.status === 'success' || modalContent.status === 'Success') && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-xs w-full shadow-2xl relative p-4 animate-in fade-in zoom-in duration-200">
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl font-bold p-1 hover:bg-gray-100 rounded-full transition-all w-8 h-8 flex items-center justify-center"
            >
              ×
            </button>
            <div className="text-center pt-2">
              <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-green-600 mb-1">Success!</h3>
              <p className="text-gray-600 text-sm">{modalContent.message}</p>
            </div>
          </div>
        </div>
      )}

      {/* REGULAR MODAL FOR ERROR/INFO */}
      {showModal && modalContent.status !== 'success' && modalContent.status !== 'Success' && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6" role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <div className="absolute inset-0 bg-black opacity-40" onClick={closeModal} />
          <div className="relative bg-white rounded-lg shadow-xl max-w-lg w-full p-6 z-10">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-700">i</div>
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold" id="modal-title">{modalContent.title}</h3>
                <p className="mt-2 text-sm text-gray-700">{modalContent.message}</p>
              </div>
              <button onClick={closeModal} aria-label="Close dialog" className="ml-4 text-gray-500 hover:text-gray-700">✕</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UIUXDesignServices;
